import { render, staticRenderFns } from "./modificarOficioEntrante.vue?vue&type=template&id=b40716bc"
import script from "./modificarOficioEntrante.vue?vue&type=script&lang=js"
export * from "./modificarOficioEntrante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports